import React from "react";
import useNightMode from "../../core/hooks/useNightMode";

function NightModeToggle() {
    const {isDark, toggle} = useNightMode();

    return (
        <button
            type="button"
            onClick={toggle}
            className="night-mode-toggle"
            title={isDark ? 'Light mode' : 'Dark mode'}
        >
            {isDark ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 14.167a4.167 4.167 0 1 0 0-8.334 4.167 4.167 0 0 0 0 8.334ZM10 1.667v1.666M10 16.667v1.666M3.517 3.517l1.175 1.175M15.308 15.308l1.175 1.175M1.667 10h1.666M16.667 10h1.666M3.517 16.483l1.175-1.175M15.308 4.692l1.175-1.175" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ) : (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.36 11.04A7.5 7.5 0 0 1 8.96 2.64a7.5 7.5 0 1 0 8.4 8.4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )}
        </button>
    );
}

export default NightModeToggle;
